import { atom } from "jotai";
import { Typo } from "@/model";

export const editingTypoAtom = atom<Typo|undefined>();
